import { type ScopedProps, useListItemContext } from '../../list-item'
import * as Comp from './list-item-description.styles'

type ListItemDescriptionProps = {
  children: string
  testID?: string
}

export const ListItemDescription = (props: ListItemDescriptionProps) => {
  const { children, __scopeListItem, testID } =
    props as ScopedProps<ListItemDescriptionProps>
  const { disabled } = useListItemContext(
    'ListItemDescription',
    __scopeListItem
  )
  return (
    <Comp.Description numberOfLines={4} isDisabled={disabled} testID={testID}>
      {children}
    </Comp.Description>
  )
}
